import jQuery from 'jquery';

/** Interface hack to reduce type errors setting up the globals */
interface GlobalThisWithJQuery {
    $: JQueryStatic;
    jQuery: JQueryStatic;
}

(globalThis as unknown as GlobalThisWithJQuery).$ = jQuery;
(globalThis as unknown as GlobalThisWithJQuery).jQuery = jQuery;
